import { CSSProperties } from 'react';

import { colors } from '@/colors';
import { Container } from '@/components/Container';

interface IAmountBarProps {
  paidAmount: number;
  openAmount: number;
  height?: CSSProperties['height'];
  width?: CSSProperties['width'];
}

export const AmountBar = ({ paidAmount, openAmount, height = 30, width }: IAmountBarProps) => {
  return (
    <Container className={'AmountBar'} sx={{ display: 'flex', flexDirection: 'row', height, width }}>
      <Container
        sx={{ height: '100%', width: 'unset', flexGrow: paidAmount, backgroundColor: colors.success }}
      ></Container>
      <Container
        sx={{ height: '100%', width: 'unset', flexGrow: openAmount, backgroundColor: colors.error }}
      ></Container>
    </Container>
  );
};
